import React, { createContext, useState, useContext, useEffect } from 'react';
import { GLPI_API } from '../api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in from localStorage
    const user = localStorage.getItem('user');
    if (user) {
      setCurrentUser(JSON.parse(user));
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      // Create the authorization header with Basic auth
      const authString = btoa(`${username}:${password}`);

      // Login to GLPI
      const response = await GLPI_API.get('/initSession', {
        headers: {
          'Content-Type': 'application/json',
          'App-Token': 'JH9lHz2wbof1dhIPBPTaiEmXB4jjOJ9Ox48Ygnqd',
          Authorization: `Basic ${authString}`,
        },
      });

      // Check if we got a session token
      if (response.data && response.data.session_token) {
        // Create user object
        const userData = {
          username,
          role: 'colaborador',
          session_token: response.data.session_token,
        };

        // Store in localStorage
        localStorage.setItem('user', JSON.stringify(userData));
        setCurrentUser(userData);
        return true;
      }

      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('user');
    setCurrentUser(null);
  };

  const value = {
    currentUser,
    login,
    logout,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
